module.exports = __webpack_public_path__ + "media/images/mailer/thumb_432-c902d7678e74dcc1402496e08dcf80ba.jpg";